export default __webpack_public_path__ + "static/media/little-birthday.5f9f62a8.png";